<template>
  <div
    v-if="postSchedule && postSchedule.published_at !== null"
    class="publish-display text-center"
  >
    <div ref="month-text" class="text-dark font-weight-bold text__post-published-month">
      {{ formatedDatetime(postSchedule.published_at, 'MMM').toUpperCase() }}
    </div>
    <div ref="day-text" class="font-weight-bold text__post-published-day h5 mb-0">
      {{ formatedDatetime(postSchedule.published_at, 'D') }}
    </div>
    <div ref="hour-text" class="text-dark text__post-published-time">
      {{ formatedDatetime(postSchedule.published_at, 'hh:mma') }}
    </div>
    <b-badge
      v-if="isOverduePublished && showBadge"
      ref="tag"
      variant="neutral-success"
      class="text-success badge__tag-published"
    >
      <div>Published</div>
    </b-badge>
  </div>
  <div v-else class="publish-display text-dark font-weight-bold text-center">NO PUBLISH DATE</div>
</template>

<script>
import { datetimeMixin } from '@/mixins/datetimeMixin';

export default {
  mixins: [datetimeMixin],

  props: {
    post: {
      type: Object,
      default: () => ({})
    },

    postSchedule: {
      type: Object,
      default: () => ({})
    },

    showBadge: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    todayDate() {
      return this.today('format');
    },

    isOverduePublished() {
      return new Date(this.todayDate) > new Date(this.postSchedule?.published_at);
    }
  }
};
</script>

<style lang="scss" scoped>
.publish-display {
  width: 100px;
}

@media only screen and (max-width: 576px) {
  .badge__tag-published {
    font-size: 55% !important;
  }
}
</style>
